import { render } from "./Accordion.vue?vue&type=template&id=a37fcbc4&scoped=true&ts=true&lang=pug"
import script from "./Accordion.vue?vue&type=script&lang=ts"
export * from "./Accordion.vue?vue&type=script&lang=ts"

import "./Accordion.vue?vue&type=style&index=0&id=a37fcbc4&lang=scss&scoped=true"

import exportComponent from "/Users/massimodeluisa/Git/Smart Squad/Esse Group/CMS Admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a37fcbc4"]])

export default __exports__